import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { useGlobalDataService } from '../../../services/ApiDataService';

const useStyles = makeStyles(() => ({
    spacing: {
        '&$passwordRequirements': {
            marginTop: 40,
        },
    },

    passwordRequirements: {},
    passwordRequirementsTitle: {
        fontSize: 16,
        fontWeight: 800,
    },
}));

function PasswordRequirements(props) {
    const { noSpacing } = props;
    const classes = useStyles();
    const rules = usePasswordComplexity();

    if (!rules) return null;

    const { passwordMinLength, validatePasswordComplexity } = rules;

    return (
        <div className={clsx(!noSpacing && classes.spacing, classes.passwordRequirements)}>
            <div className={classes.passwordRequirementsTitle}>Password Requirements:</div>
            <ul>
                <li>must be at least {passwordMinLength} characters</li>
                {validatePasswordComplexity && (
                    <>
                        <li>must have at least one lower case character</li>
                        <li>must have at least one upper case character</li>
                        <li>must contain at least one digit</li>
                    </>
                )}
            </ul>
        </div>
    );
}

export default PasswordRequirements;

PasswordRequirements.propTypes = {
    noSpacing: PropTypes.bool,
};

PasswordRequirements.defaultProps = {
    noSpacing: false,
};

/**
 * Password Complexity needs to come from a public route as this is used in the password reset pages
 * which may or may not have a valid session
 */
function usePasswordComplexity() {
    const dataService = useGlobalDataService();
    const [data, setData] = useState();

    useEffect(() => {
        doGet();

        async function doGet() {
            const passwordRules = await dataService.get('/ipm/public/systemconfiguration/getPasswordRule');

            setData(passwordRules);
        }
    }, [dataService]);

    return data;
}
